import React from "react";
import config from "../../environments/config";
import "./EnvironmentBanner.css";

// Non-prod environments only differ by URL, so make them visibly different.
// Prod renders nothing: anything coloured means "not prod".
const ENVIRONMENTS = {
  local: { label: "LOCAL", color: "#6c757d" },
  dev: { label: "DEV", color: "#e8590c" },
  westus: { label: "DEV WEST US", color: "#0c8599" },
  qa: { label: "QA", color: "#7048e8" },
};

export function getEnvironment(name = config.name, isProd = config.isProd) {
  if (isProd === true || isProd === "true") return null;
  const key = (name || "").toLowerCase();
  if (ENVIRONMENTS[key]) return ENVIRONMENTS[key];
  // Unknown non-prod build: still flag it rather than look like prod.
  return key ? { label: key.toUpperCase(), color: "#c92a2a" } : null;
}

function EnvironmentBanner() {
  const env = getEnvironment();
  if (!env) return null;
  return (
    <div
      className="env-banner"
      style={{ "--env-color": env.color }}
      role="status"
      aria-label={`${env.label} environment`}
      data-testid="environment-banner"
    >
      <span className="env-banner__label">{env.label}</span>
    </div>
  );
}

export default EnvironmentBanner;
